






















































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Shared
import DeviceType from '@/components/shared/DeviceType.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'

// Component
import CardList from '@/components/card/CardList.vue'
import BeaconCarriedList from '@/components/beacon/BeaconCarriedList.vue'

// Model
import CardModel from '@/_models/CardModel'
import BeaconModel from '@/_models/BeaconModel'

@Component({
  components: {
    DeviceType,
    NotFound,
  },
  computed: {},
})
export default class DeviceList extends mixins(CardList, BeaconCarriedList) {
  @Prop()
  card!: CardModel

  @Prop()
  beacon!: BeaconModel

  cardList: CardModel[] = []
  beaconList: BeaconModel[] = []

  deviceTypeSeleted: any = {
    id: 0,
    name: '',
    device_type: '',
  }
  cardSelected: any = new CardModel()
  beaconSelected: any = new BeaconModel()
  selectedMode = 'single'

  deviceTypes = {
    card: {
      id: 1,
      name: 'JCards',
      device_type: 'card',
    },
    beacon: {
      id: 2,
      name: 'Beacons',
      device_type: 'beacon',
    },
  }

  onSelectDeviceTypeByName(deviceTypeName: string) {
    const typeSelected = this.deviceTypes[deviceTypeName]
    if (typeSelected) {
      this.onDeviceTypeSelected(typeSelected)
    }
  }

  onDeviceTypeSelected(deviceType: any) {
    if (deviceType.id) {
      this.deviceTypeSeleted = deviceType
    }
  }

  onAutoSelectDevice(deviceId: string, isCardType: boolean) {
    if (isCardType) {
      const cardSelected = this.cards.find((item) => item.san_id === deviceId)
      this.onCardSelected(cardSelected as CardModel)
    } else {
      const beaconSelected = this.beacons.find((item) => item._id === deviceId)
      this.onBeaconSelected(beaconSelected as BeaconModel)
    }

    this.onSelectDeviceTypeByName(isCardType ? 'card' : 'beacon')
  }

  onCardSelected(card: CardModel) {
    if (card._id) {
      this.cardSelected = card
      this.beaconSelected = new BeaconModel()
      this.$emit('cardSelected', card)
      this.$emit('beaconSelected', this.beaconSelected)
      this.$emit('onDeviceSelected', card.user_id)
    }
  }

  onBeaconSelected(beacon: BeaconModel) {
    if (beacon._id) {
      this.beaconSelected = beacon
      this.cardSelected = new CardModel()
      this.$emit('beaconSelected', beacon)
      this.$emit('cardSelected', this.cardSelected)
      this.$emit('onDeviceSelected', beacon.user_id)
    }
  }

  onBack() {
    if (this.deviceTypeSeleted.id) {
      this.deviceTypeSeleted = {
        id: 0,
        name: '',
        device_type: '',
      }
      this.cardSelected = new CardModel()
      this.beaconSelected = new BeaconModel()
    }
  }

  @Watch('card')
  changeCardSelected() {
    if (this.card._id) {
      this.cardSelected = this.card
      this.cardList = this.cards.map((item) => {
        if (this.card._id === item._id) {
          return this.card
        }
        return item
      })
    }
  }

  @Watch('beacon')
  changeBeaconSelected() {
    if (this.beacon._id) {
      this.beaconSelected = this.beacon
      this.beaconList = this.beacons.map((item) => {
        if (this.beacon._id === item._id) {
          return this.beacon
        }
        return item
      })
    }
  }
}
